export default {
    tabs1: "公司用戶",
    tabs2: "個人用戶",
    // 公司部分
    title1: "登錄資料",
    title2: "公司資料",
    id: "ID",
    username: "登錄名",
    unameNorm1: "註冊後不能修改",
    unameNorm2: "長度為6~32個字符（2~10個中文）",
    unameNorm3: "不可包含空格或特殊字符",
    unameNorm4: "支持數字，大小寫字母，中文",
    pwdNorm1: "長度為8~32個字符",
    pwdNorm2: "不可包含空格",
    pwdNorm3: "支持數字，大小寫字母",
    pwd: "密碼",
    cpwd: "密碼確認",
    email: "電子郵箱",
    companyname: "公司名稱（中）",
    en_companyname: "公司名稱（英）",
    consignee: "聯絡人姓名",
    mobile: "聯繫電話",
    fax_company: "公司傳真",
    address1: "公司地址",
    address2: "地址",
    industry: "所屬市場",
    market: "公司類別",
    license: "營業執照",
    code: "驗證碼",
    forSure: "我已閱讀并同意",
    errpwd: "請輸入密碼",
    errcpwd: "請再次輸入密碼",
    errdiff: "兩次輸入密碼不一致",
    errcode: "驗證碼不正確，請重新輸入",
    erruname: "請輸入登錄名",
    errcompanyname: "請輸入公司名稱（中文）",
    erren_companyname: "請輸入公司名稱（英文）",
    errconsignee: "請輸入聯絡人姓名",
    errmobile: "請輸入聯繫電話",
    errfax: "請輸入傳真",
    erraddress: "請輸入地址",
    errindustry: "請選擇市場",
    errmarket: "請選擇公司類別",
    succregister: "註冊完成！",
    agreement: "協議條款"
}